/**
 * Prototype configuration of the IPX Scan-to-BIM integration (PDI-538).
 * Everything that talks to IPX is mocked by the static pages in public/ipx-mock.
 */

const BYTES_PER_GB = 1024 ** 3;

// IPX has not confirmed its limit yet: 10 GB, 40-60 GB and 100 GB are in circulation
const SIZE_LIMIT_GB = 40;

// Used when the point cloud element does not report its file size
const FALLBACK_TOTAL_GB = 25;

/** Largest point cloud region IPX accepts */
export const IPX_MOCK_SIZE_LIMIT_BYTES = SIZE_LIMIT_GB * BYTES_PER_GB;

/** Size assumed for point clouds that don't report their file size */
export const IPX_MOCK_FALLBACK_TOTAL_BYTES = FALLBACK_TOTAL_GB * BYTES_PER_GB;

/** Public website of IPX, where customers can learn who provides the service */
export const IPX_WEBSITE_URL = "https://ipx.integrated-projects.com";

/** Embedded ordering surface, served from this origin while mocked */
export const IPX_EMBED_URL = "/ipx-mock/index.html";

/** Page where the customer follows the order at IPX */
export const IPX_ORDER_STATUS_URL = "/ipx-mock/status.html";

/** Format of the point cloud exported for IPX */
export const IPX_EXPORT_FORMAT = "e57";
